import React from "react";

type Props = {
  color?: string;
  style?: React.CSSProperties;
};

export const IdCardSvg: React.FC<Props> = ({ style, color = "#999" }) => {
  return (
    <svg
      fill={color}
      width="100px"
      height="100px"
      viewBox="0 0 32 32"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      style={{ ...style }}
    >
      <title>id-card</title>
      <path d="M28 5.25h-24c-1.518 0.002-2.748 1.232-2.75 2.75v16c0.002 1.518 1.232 2.748 2.75 2.75h24c1.518-0.002 2.748-1.232 2.75-2.75v-16c-0.002-1.518-1.232-2.748-2.75-2.75h-0zM4 6.75h24c0.69 0.001 1.249 0.56 1.25 1.25v1.25h-26.5v-1.25c0.001-0.69 0.56-1.249 1.25-1.25h0zM28 25.25h-24c-0.69-0.001-1.249-0.56-1.25-1.25v-13.25h26.5v13.25c-0.001 0.69-0.56 1.249-1.25 1.25h-0zM9.645 17.628c1.455 0 2.635-1.18 2.635-2.635s-1.18-2.635-2.635-2.635c-1.455 0-2.635 1.18-2.635 2.635v0c0.001 1.455 1.18 2.633 2.635 2.635h0zM9.645 13.858c0.627 0 1.135 0.508 1.135 1.135s-0.508 1.135-1.135 1.135c-0.627 0-1.135-0.508-1.135-1.135 0 0 0 0 0 0v0c0.001-0.627 0.508-1.134 1.135-1.135h0zM9.645 18.811c-2.15 0.009-3.947 1.51-4.41 3.52l-0.006 0.031c-0.011 0.048-0.017 0.103-0.017 0.16 0 0.414 0.336 0.75 0.75 0.75 0.357 0 0.656-0.25 0.731-0.585l0.001-0.005c0.309-1.366 1.512-2.371 2.951-2.371s2.642 1.005 2.947 2.351l0.004 0.020c0.077 0.338 0.375 0.587 0.732 0.587 0.414 0 0.75-0.336 0.75-0.75 0-0.056-0.006-0.11-0.018-0.163l0.001 0.005c-0.469-2.041-2.265-3.541-4.414-3.551h-0.001zM26 13.25h-8c-0.414 0-0.75 0.336-0.75 0.75s0.336 0.75 0.75 0.75v0h8c0.414 0 0.75-0.336 0.75-0.75s-0.336-0.75-0.75-0.75v0zM26 17.25h-8c-0.414 0-0.75 0.336-0.75 0.75s0.336 0.75 0.75 0.75v0h8c0.414 0 0.75-0.336 0.75-0.75s-0.336-0.75-0.75-0.75v0zM26 21.25h-8c-0.414 0-0.75 0.336-0.75 0.75s0.336 0.75 0.75 0.75v0h8c0.414 0 0.75-0.336 0.75-0.75s-0.336-0.75-0.75-0.75v0z"></path>
    </svg>
  );
};
